import axios from "../utils/axios"

export const getCurrencies = () => {
    return new Promise((resolve, reject) => {
        axios({ method: "get", url: "/currencies", showLoader: false, authorization: false }).then((resp) => {
            resolve(resp)
        }).catch(e => {
            reject(e)
        })
    })
}